// H5 hotel module routes.
import type { RouteRecordRaw } from "vue-router";

export const hotelRoutes: RouteRecordRaw[] = [
  {
    path: "/hotel",
    name: "hotel",
    component: () => import("@/modules/hotel/pages/HotelPage.vue"),
  },
];
